import { useEffect, useState } from "react";

import { api } from "@/services/api";

/**
 * Hook to check if development features are enabled.
 * Fetches the flag from the API (single source of truth).
 */
export const useDevFeatures = () => {
  const [devFeaturesEnabled, setDevFeaturesEnabled] = useState(false);

  useEffect(() => {
    api
      .getDevFeatures()
      .then((res) => setDevFeaturesEnabled(res.dev_features_enabled))
      .catch(() => setDevFeaturesEnabled(false));
  }, []);

  return { devFeaturesEnabled };
};
